import styled from 'styled-components';

import { layout } from '../../../../package.json';

export const Root = styled.div`
  width: 100%;
  padding: 0 2%;
`

export const Container = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 3rem auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--fontcolor);
  .mg-b-16 {
    margin-bottom: 16px;
  }
`;

export const ContainerMyFavorite = styled.div`
  width: 100%;
`;

export const MyFavoriteTitle = styled.div`
  width: 100%;
  margin-bottom: 2rem;
  span {
    font-size: 1.25rem;
    font-weight: 600;
  }

  p {
    margin-top: 1rem;
  }
`;

export const ProductsList = styled.div`
  width: 100%;
  background: #f7f7f7;
  padding: 1rem 2%;
  border-radius: 1rem;
`;

export const AlertMessageContainer = styled.div`
  width:100%;
  background-color: var(--primary);
  color: white;
  border-radius: 8px;
  text-align: center;
  span {
    padding: 2%;
    width: 100%;
  }
`

export const ProductRow = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  & + div {
    margin-top: 1rem;
  }

  width: 100%;
  padding: 1rem 2%;
  border-radius: 0.9rem;
  background: #fff;

  section {
    width: 100%;
    display: flex;
  }

  @media (max-width: ${layout.tablet}) {
    flex-direction: column;
  }
`;

export const ContainerImagem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 195px;
  height: 100%;

  @media (max-width: ${layout.mobile}) {
    width: 95px;
    height: 100%;
  }
`;

export const ProductImagem = styled.div`
  width: 100%;
  max-width: 115px;
  border-radius: 0.9rem;

  img {
    border-radius: 0.9rem;
    width: 100%;
  }
`;

export const ContainerDetal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;

  width: 100%;
  padding: 0 2%;
`;

export const ProductTitle = styled.div`
  padding: 6px;

  span {
    font-size: 20px;
    font-weight: 400;
  }

  @media (max-width: ${layout.mobile}) {
    width: 250px;
    span {
      font-size: 11px;
    }
  }
`;

export const ProductCategory = styled.div`
  padding: 6px;

  span {
    color: var(--gray-light);
    font-size: 17px;
    font-weight: 400;
  }

  @media (max-width: ${layout.mobile}) {
    span {
      font-size: 10px;
    }
  }
`;

export const ContainerActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: stretch;

  width: 100%;

  text-align: center;

  div + div {
    margin-left: 1rem;
  }
`;

export const ButtonAdd = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  max-width: 15rem;

  padding: 0.5rem 1rem;

  border: 1px solid var(--btn-finish);
  border-radius: 0.9rem;
  background-color: var(--btn-finish);

  cursor: pointer;

  span {
    color: #fff;
    font-size: 1rem;
    font-weight: 800;
  }

  svg {
    display: none;
  }
`;

export const ButtonRemove = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  max-width: 15rem;

  padding: 0.5rem 1rem;

  border: 1px solid var(--btn-canc);
  border-radius: 0.9rem;
  background-color: var(--btn-canc);

  cursor: pointer;

  span {
    color: #fff;
    font-size: 1rem;
    font-weight: 800;
  }

  svg {
    display: none;
  }
`;
